import { Component, OnInit, Inject, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AddRoleModel } from 'src/app/viewModels/roles/rolesdetail';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/middleware/common/common.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { RoleService } from '../services/role.service';
import { PermissionService } from '../../permissions/services/permission/permission.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-role-detailss',
  templateUrl: './role-detailss.component.html',
  styleUrls: ['./role-detailss.component.scss']
})
export class RoleDetailssComponent implements OnInit,AfterViewChecked {

  @ViewChild('name', {static: true}) rolename:ElementRef;
  roleDetailform: FormGroup;
  roleDetail: AddRoleModel = new AddRoleModel();
  titleAlert = 'This field is required';
  permissionResponseHolder: any;
  dropdownSettings = {};
  dropdownList: any[] = [];
  permList: any[] = [];
  tempArrayToHoldPermission: any[] = [];
  permissionList: any[] = [];
  selectedItems = [];
  closePannel:boolean = false;
  getUserListModel = {
    databaseID: 0,
    organizationID: 0
  }
  currentUser: any;
  @Output() closeSidePanel = new EventEmitter();
 
  databaseId: string;
  organizationId: string;
  OfficeIDList: any=[];
  myOfficeID: any;
  constructor(
    private formBuilder: FormBuilder, private commonService: CommonService,
    private roleService: RoleService, private permissionService: PermissionService,
    private paginationVm: PaginationViewModel, private mulstiselect: MultiselectVM,
    private loaderService: LoaderService, private toastr: ToastrService,
    private statusConstant: StatusConstant, private router: Router,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses) {

    this.getUserListModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.organizationId = sessionStorage.getItem('organizationID');
    this.getUserListModel.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    this.createForm();
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    
  }

  ngOnInit(): void {
    // this.dropdownList = [
    //   { item_id: 1, item_text: 'Mumbai' },
    //   { item_id: 2, item_text: 'Bangaluru' },
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' },
    //   { item_id: 5, item_text: 'New Delhi' }
    // ];
    // this.selectedItems = [
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' }
    // ];
    this.dropdownSettings = {
      "singleSelection": false,
      "defaultOpen": false,
      "idField": "permissionID",
      "textField": "permissionName",
      "selectAllText": "Select All",
      "unSelectAllText": "UnSelect All",
      "enableCheckAll": true,
      "allowSearchFilter": true
    };

    // this.dropdownSettings:IDropdownSettings = {
    //   singleSelection: false,
    //   idField: 'item_id',
    //   textField: 'item_text',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true
    // };

    this.rolename.nativeElement.focus();
    this.paginationVm.pageIndex = 0;
    this.paginationVm.pageSize = 0;
    this.getPermissionData();
    
  }

  ngAfterViewChecked(): void {
    // setTimeout(() => {
    //   this.rolename.nativeElement.focus();
    // }, 1);
  }

  createForm() {
    this.roleDetailform = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      selectedPermission: ['']
     // selectedPermission: ['', Validators.required]
    });
  }

  get name() {
    return this.roleDetailform.get('name') as FormControl
  }

  async save(data) {
    let permissionList = [];
    this.roleDetail.Name = data.name;
    this.roleDetail.Description = data.description;
    this.roleDetail.databaseID = this.getUserListModel.databaseID;
    this.roleDetail.organizationID = this.getUserListModel.organizationID;
    this.roleDetail.isActive = true;
    this.roleDetail.CreatedBy = this.currentUser.UID;
    this.roleDetail.officeID=this.myOfficeID;
    data.selectedPermission.forEach(element => {
     // let id = Number(element.permissionID);
      permissionList.push(Number(element.permissionID));
    });
    this.roleDetail.rolePermissions =permissionList;    
    this.loaderService.show();
    const result = await this.roleService.addRole(this.roleDetail).toPromise();
    if (result.status === this.statusConstant.statusSuccess) {
      this.loaderService.hide();
      this.toastr.success("Role created successfully.", '', {
        timeOut: 3000,
      });
      let closePanel = true;
      this.closeSidePanel.emit(closePanel);
      this.roleDetailform.reset();     
    }
    else {
      this.toastr.error(result.message, '', {
        timeOut: 3000,
      });
      this.loaderService.hide();
      let closePanel = false;
      this.closeSidePanel.emit(closePanel);
    }    
  }

  @Output() getcloseCreateRole = new EventEmitter<boolean>();


  close(any) {
    let closePanel = false;
    this.roleDetailform.reset();
    this.closeSidePanel.emit(closePanel);
    this.getcloseCreateRole.emit(any);
  }

  getPermissionData() {
    var ReqModel={
      pageIndex: 0,
      pageSize: 0,    
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeIDList:this.OfficeIDList,
      officeID:this.myOfficeID
    }
    this.permissionService.getAllPermissions(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.permissionResponseHolder = response;
        //this.permList = this.permissionResponseHolder.data.permissionsModel;        
        this.dropdownList = this.permissionResponseHolder.data.permissionsModel;  
      }
    });
    }

 

}
